import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PalauFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15738'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15738)'>
				<rect
					width='20'
					height='14'
					fill='#65C6EE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.04743 11.2C11.4144 11.2 13.3331 9.31965 13.3331 7.00005C13.3331 4.68045 11.4144 2.80005 9.04743 2.80005C6.6805 2.80005 4.76172 4.68045 4.76172 7.00005C4.76172 9.31965 6.6805 11.2 9.04743 11.2Z'
					fill='#FFE044'
				/>
			</g>
		</svg>
	);
};

export default PalauFlagIcon;
